import { rawNavigationItems } from "Public/components/NavigationDrawer/utils/rawNavigationItems";

export const parseNavigationItems = (user) => {
  return rawNavigationItems(user)
    .map((item) => {
      if (!item.hasAccess) return undefined;
      if (item.subItems && item.subItems.length) {
        item.subItems = item.subItems.filter((subItem) => subItem.hasAccess);
      }
      return item;
    })
    .filter((item) => !!item);
};
